import { defineStore } from 'pinia';
import { useAuthStore } from '@/stores/index';
import { Ref } from 'vue';
import { ISubmissionDTO, SubmissionDTO } from '@/dtos';
import { useQuery, useQueryClient } from '@tanstack/vue-query';
import { useUpdateStatusStore } from '../updateStatus';
import { getSubmissionAPI } from '@/services/admin';

export const useAdminRegistrationStore = defineStore('admin-registraion', () => {
  const authStore = useAuthStore();

  const statusStore = useUpdateStatusStore();
  const queryClient = useQueryClient();

  const getTeamRegistration = (yearId: Ref<string>, teamId: Ref<string>) => {
    return useQuery({
      queryKey: ['team-registration', yearId.value, teamId.value],
      queryFn: async (): Promise<ISubmissionDTO> => {
        if (!yearId.value) throw new Error('yearId not set');
        if (!teamId.value) throw new Error('teamId not set');

        const ret = await getSubmissionAPI(teamId.value, yearId.value);
        const submission = new SubmissionDTO(ret);
        return submission;
      },
      enabled: () =>
        !!authStore.isAdmin &&
        !!yearId.value &&
        yearId.value != '' &&
        !!teamId.value &&
        teamId.value != '',
    });
  };

  const invalidate = (yearId: Ref<string>, teamId: Ref<string>) => {
    queryClient.invalidateQueries({ queryKey: ['team-registration', yearId.value, teamId.value] });
  };

  return {
    getTeamRegistration,
    invalidate,
  };
});
